import React, { memo } from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { routerAnimationExit, routerAnimationFrom, routerAnimationTo, routerAnimationTransition } from "../../hooks/animations";
import "./blog.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import blogs from "../../FakeData/Blogs/blogs";

const Blogs = () => {
  return (
    <motion.div
      className="pt-24 pb-5 md:px-10 px-5 min-h-screen"
      initial={routerAnimationFrom}
      animate={routerAnimationTo}
      transition={routerAnimationTransition}
      exit={routerAnimationExit}
    >
      <Helmet>
        <title>Blogs - Sheikh Shahariar Siam</title>
      </Helmet>
      <div>
        <div className=" mb-5 lg:mb-10">
          <h1 className=" lg:mb-10 mb-5 text-center">
            <span className="text-accent text-4xl title-font blog-title relative z-30">My Blogs</span>
          </h1>
          <p className="text-center italic text-primary">Blogs that Written by me</p>
        </div>
        <div>
          {blogs.map((blog) => (
            <div className="blogOne lg:mb-10 mb-5">
              <div className="lg:flex gap-10">
                <div>
                  <h1 className="text-primary sm:text-3xl text-2xl mb-3 pl-5 font-bold">{blog.publishedDate}</h1>
                  <LazyLoadImage class="rounded-xl" src={blog.img} effect="blur" placeholderSrc={blog.placeholderImage} />
                </div>
                <div className="flex justify-center items-center">
                  <div class="flex flex-col py-5 gap-2 text-neutral-content">
                    <h2 class="card-title text-primary text-2xl">{blog.title}</h2>
                    <p className="text-justify">{blog.description}</p>
                    <a href={blog.detailsLInk} rel="noreferrer" target="_blank" className="cursor-pointer link-accent link-hover">
                      Continue reading....
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default memo(Blogs);
